import { combineEpics, type Epic } from 'redux-observable';
import { filter } from 'rxjs';
import { request } from '@/core';
import { createIncidentRequest } from '@/api/events';
import { createIncident } from '../actions';

const createIncidentEpic: Epic = (action$) =>
  action$.pipe(
    filter(createIncident.match),
    request(({ payload }) => createIncidentRequest(payload), createIncident),
  );

export default combineEpics(createIncidentEpic);
